import createVueComponent from '../createVueComponent';

const Edit2 = createVueComponent('Edit2Icon', [
  ['path', { d: 'M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z' }],
]);

export default Edit2;
